export default __webpack_public_path__ + "static/media/mh-bedroom-4th-01.3462d48b.jpg";